import Splide from "@splidejs/splide";
import lightGallery from "lightgallery";

// Mount a Splide carousel defensively: loop mode needs enough real slides to
// clone cleanly (too few causes broken/hidden arrows), and a mount failure in
// one carousel must never stop the rest of this script from running.
function mountCarousel(id, options) {
  var el = document.getElementById(id);
  if (!el) return;
  try {
    var slideCount = el.querySelectorAll(".splide__slide").length;
    var opts = Object.assign(
      {
        type: slideCount >= 3 ? "loop" : "slide",
        perPage: 1,
        direction: "rtl",
        autoHeight: true,
      },
      options
    );
    if (typeof opts.arrows === "function") opts.arrows = opts.arrows(slideCount);
    if (typeof opts.pagination === "function") opts.pagination = opts.pagination(slideCount);
    if (typeof opts.autoplay === "function") opts.autoplay = opts.autoplay(slideCount);
    new Splide(el, opts).mount();
  } catch (err) {
    console.error("splide #" + id + " failed to mount", err);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // top menu mobile toggle
  if (document.querySelector(".togle")) {
    document.querySelectorAll(".togle").forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        var nav = toggle.closest("nav");
        var menu = nav ? nav.querySelector(".mega_menu_list") : null;
        if (menu) {
          menu.classList.toggle("max-[799px]:hidden");
          menu.classList.toggle("mobile-open");
        }
      });
    });
  }

  // mobile submenu arrow toggles
  document.querySelectorAll(".sub-toggle").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var li = btn.closest("li");
      if (li) li.classList.toggle("sub-open");
    });
  });

  // mobile menu close button
  document.querySelectorAll(".mobile-close-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var nav = btn.closest("nav");
      var menu = nav ? nav.querySelector(".mega_menu_list") : null;
      if (menu) {
        menu.classList.add("max-[799px]:hidden");
        menu.classList.remove("mobile-open");
      }
    });
  });

  // back to top button
  var backToTop = document.getElementById("back");
  if (backToTop) {
    backToTop.classList.add("hidden");
    window.addEventListener("scroll", function () {
      if (window.scrollY > 500) {
        backToTop.classList.remove("hidden");
      } else {
        backToTop.classList.add("hidden");
      }
    });
    var scrollTopLink = document.querySelector(".scrolltop");
    if (scrollTopLink) {
      scrollTopLink.addEventListener("click", function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  }

  // header tooltip toggle (FRONT_J)
  var tooltip = document.getElementById("tooltip");
  if (tooltip) {
    tooltip.addEventListener("click", function () {
      var text = tooltip.querySelector(".text");
      if (text) {
        text.classList.toggle("hidden");
      }
    });
  }

  // news ticker (FRONT_A) — rotates #newsList <li> items into #newsData
  var newsList = document.getElementById("newsList");
  var newsData = document.getElementById("newsData");
  if (newsList && newsData) {
    var items = Array.prototype.slice.call(newsList.querySelectorAll("li"));
    if (items.length) {
      newsList.classList.add("hidden");
      var count = 0;
      var interval = null;

      var showNext = function () {
        newsData.classList.add("opacity-0");
        setTimeout(function () {
          newsData.innerHTML = items[count].innerHTML;
          newsData.classList.remove("opacity-0");
          count = (count + 1) % items.length;
        }, 300);
      };

      var start = function () {
        interval = setInterval(showNext, 4000);
      };
      var stop = function () {
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
      };

      showNext();
      start();
      newsData.addEventListener("mouseenter", stop);
      newsData.addEventListener("mouseleave", start);
    }
  }

  // home top news hero carousel (FRONT_B)
  mountCarousel("top_news", {
    arrows: false,
    pagination: function (n) {
      return n > 1;
    },
    autoplay: true,
    interval: 4000,
    speed: 1500,
  });

  // multimedia gallery carousel (FRONT_I) — manual arrows only, no autoplay
  mountCarousel("multimedia", {
    arrows: function (n) {
      return n > 1;
    },
    pagination: false,
    autoplay: false,
  });

  // home gallery carousel (FRONT_C) — auto-rotate + manual arrows
  mountCarousel("adaptive", {
    arrows: function (n) {
      return n > 1;
    },
    pagination: false,
    autoplay: true,
    interval: 4000,
    speed: 1500,
  });

  // poll vote + statistics (poll/form)
  document.querySelectorAll("form.pollForm").forEach(function (form) {
    var status = form.querySelector("#pollStatus");
    var setStatus = function (text) {
      if (status) {
        status.classList.remove("hidden");
        status.textContent = text;
      }
    };

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      setStatus("در حال ارسال...");
      var pId = form.querySelector('input[name="poll_id"]').value;
      var checked = form.querySelector('input[name="poll_option"]:checked');
      fetch(window.masterConfig.baseUrl + "polls/submit/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          BHT: window.masterConfig.blackHoleToken,
          pId: pId,
          optId: checked ? checked.value : "",
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("request failed");
          return res.json();
        })
        .then(function () {
          setStatus("ثبت رای با موفقیت انجام شد.");
        })
        .catch(function () {
          setStatus("ثبت رای با مشکل مواجه شد!");
        });
    });

    var statsBtn = form.querySelector("[data-statistic]");
    if (statsBtn) {
      statsBtn.addEventListener("click", function () {
        var pId = statsBtn.getAttribute("data-statistic");
        fetch(window.masterConfig.baseUrl + "polls/statistics/", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({ pId: pId }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var list = form.querySelector("[data-poll-options]");
            var actions = form.querySelector("[data-poll-actions]");
            if (!list || !data || !data.options) return;
            list.innerHTML = "";
            Object.keys(data.options).forEach(function (optId) {
              var opt = data.options[optId];

              var li = document.createElement("li");
              li.className = "mb-2";

              var row = document.createElement("div");
              row.className =
                "mb-1 flex items-center justify-between text-sm text-ink";
              var titleSpan = document.createElement("span");
              titleSpan.textContent = opt.title;
              var pctSpan = document.createElement("span");
              pctSpan.className = "text-body";
              pctSpan.textContent = opt.percent + "% (" + opt.count + ")";
              row.appendChild(titleSpan);
              row.appendChild(pctSpan);

              var barBg = document.createElement("div");
              barBg.className =
                "h-2 w-full overflow-hidden rounded-full bg-line";
              var bar = document.createElement("div");
              bar.className = "h-full rounded-full bg-brand";
              bar.style.width = opt.percent + "%";
              barBg.appendChild(bar);

              li.appendChild(row);
              li.appendChild(barBg);
              list.appendChild(li);
            });
            if (actions) actions.classList.add("hidden");
          });
      });
    }
  });

  // company news tabs (FRONT_N) — replaces the old jQuery ajax + template plugin
  var companyTabs = document.querySelector("[data-company-tabs]");
  var companyContent = document.querySelector("[data-company-content]");
  if (companyTabs && companyContent) {
    var moreNewsLink = document.getElementById("moreNews");
    var companyFeatured = companyContent.querySelector(
      "[data-company-featured]"
    );
    var companyList = companyContent.querySelector("[data-company-list]");

    var defaultImage = function (news) {
      return news.primaryFile && news.primaryFile.picture
        ? news.primaryFile.picture
        : "/images/default_fa/default-big.jpg";
    };

    var buildFeatured = function (news) {
      var frag = document.createDocumentFragment();

      var a = document.createElement("a");
      a.href = news.url;
      a.target = "_blank";
      a.title = news.title;
      a.className = "block";
      var img = document.createElement("img");
      img.src = defaultImage(news);
      img.alt = news.title;
      img.width = 633;
      img.height = 371;
      img.className = "h-[340px] w-full bg-line object-cover";
      a.appendChild(img);
      frag.appendChild(a);

      var caption = document.createElement("div");
      caption.className =
        "absolute inset-x-0 bottom-0 bg-[rgba(10,10,10,0.82)] px-4 py-3";
      var h5 = document.createElement("h5");
      var titleLink = document.createElement("a");
      titleLink.href = news.url;
      titleLink.target = "_blank";
      titleLink.title = news.title;
      titleLink.className =
        "line-clamp-1 block text-sm font-bold text-white hover:text-line min-[800px]:text-base";
      titleLink.textContent = news.title;
      h5.appendChild(titleLink);
      caption.appendChild(h5);
      frag.appendChild(caption);

      return frag;
    };

    var buildLinked = function (news) {
      var row = document.createElement("div");
      row.className = "flex gap-3 border-b border-line py-2 last:border-b-0";

      var a = document.createElement("a");
      a.href = news.url;
      a.target = "_blank";
      a.title = news.title;
      a.className = "block shrink-0";
      var img = document.createElement("img");
      img.src = defaultImage(news);
      img.alt = news.title;
      img.width = 128;
      img.height = 96;
      img.className = "h-24 w-[128px] bg-line object-cover";
      a.appendChild(img);
      row.appendChild(a);

      var textWrap = document.createElement("div");
      textWrap.className = "min-w-0 flex-1";
      var h5 = document.createElement("h5");
      var titleLink = document.createElement("a");
      titleLink.href = news.url;
      titleLink.target = "_blank";
      titleLink.title = news.title;
      titleLink.className =
        "line-clamp-2 min-h-10 block text-sm font-bold text-brand hover:text-ink";
      titleLink.textContent = news.title;
      h5.appendChild(titleLink);
      textWrap.appendChild(h5);
      var p = document.createElement("p");
      p.className = "mt-1 line-clamp-2 min-h-8 text-xs text-body";
      p.textContent = news.lead || "";
      textWrap.appendChild(p);
      row.appendChild(textWrap);

      return row;
    };

    var renderCompanyNews = function (rows) {
      if (!companyFeatured || !companyList) return;
      var list = Array.isArray(rows)
        ? rows
        : rows && typeof rows === "object"
        ? Object.keys(rows).map(function (k) {
            return rows[k];
          })
        : [];
      companyFeatured.innerHTML = "";
      companyList.innerHTML = "";
      if (!list.length) return;
      companyFeatured.appendChild(buildFeatured(list[0]));
      list.slice(1).forEach(function (news) {
        companyList.appendChild(buildLinked(news));
      });
    };

    companyTabs
      .querySelectorAll("button[data-category-id]")
      .forEach(function (btn) {
        btn.addEventListener("click", function () {
          var catId = btn.getAttribute("data-category-id");

          fetch(
            window.masterConfig.baseUrl +
              "newsstudios/ajaxList/?" +
              new URLSearchParams({
                categories: catId,
                limit: 4,
                fields: "title,upTitle,lead,publish_time,primaryFile",
                leadChars: 60,
                "primaryFile[w]": 633,
                "primaryFile[h]": 377,
                "primaryFile[zc]": 1,
              }).toString(),
            { method: "GET" }
          )
            .then(function (res) {
              return res.json();
            })
            .then(function (data) {
              companyTabs
                .querySelectorAll("button[data-category-id]")
                .forEach(function (b) {
                  b.classList.remove("text-brand");
                  b.classList.add("text-ink");
                });
              btn.classList.remove("text-ink");
              btn.classList.add("text-brand");
              if (moreNewsLink) {
                moreNewsLink.href =
                  "/newsstudios/archive/?curp=1&categories=" + catId;
              }
              renderCompanyNews(data);
            })
            .catch(function (err) {
              console.error("company tabs ajaxList failed", err);
            });
        });
      });
  }

  // article extra-files gallery carousel (content/gallery)
  mountCarousel("carousel", {
    arrows: function (n) {
      return n > 1;
    },
    pagination: false,
    autoplay: false,
  });

  // album lightbox (replaces the old jQuery fancybox plugin) — Layouts/album.ctp
  var albumLightbox = document.getElementById("album-lightbox");
  var albumThumbs = document.querySelector("[data-album-thumbs]");
  if (albumLightbox && albumThumbs) {
    try {
      var albumSplideEl = document.getElementById("album-lightbox-splide");
      var albumSlideCount = albumSplideEl.querySelectorAll(".splide__slide").length;
      var albumSplide = new Splide(albumSplideEl, {
        type: albumSlideCount >= 3 ? "loop" : "slide",
        perPage: 1,
        arrows: albumSlideCount > 1,
        pagination: false,
        direction: "rtl",
        height: "100%",
      }).mount();

      var openLightbox = function (index) {
        albumLightbox.classList.remove("hidden");
        document.body.style.overflow = "hidden";
        albumSplide.refresh();
        albumSplide.go(index);
      };
      var closeLightbox = function () {
        albumLightbox.classList.add("hidden");
        document.body.style.overflow = "";
      };

      albumThumbs.querySelectorAll("[data-album-index]").forEach(function (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          openLightbox(parseInt(link.getAttribute("data-album-index"), 10) || 0);
        });
      });

      var closeBtn = albumLightbox.querySelector("[data-album-close]");
      if (closeBtn) closeBtn.addEventListener("click", closeLightbox);

      albumLightbox.addEventListener("click", function (e) {
        if (e.target === albumLightbox) closeLightbox();
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !albumLightbox.classList.contains("hidden")) {
          closeLightbox();
        }
      });
    } catch (err) {
      console.error("album lightbox failed to mount", err);
    }
  }

  // inline CMS-embedded photo gallery (parse_content/gallery.twig) — replaces
  // the old jQuery GalleryMaker + carouFredSel widget with a thumbnail grid
  // that opens lightGallery on click.
  document.querySelectorAll("[data-inline-gallery]").forEach(function (container) {
    var galleryId = container.getAttribute("data-gallery-id");
    if (!galleryId) return;

    var body = new URLSearchParams();
    body.append("id", galleryId);
    body.append("parameters[original][w]", 600);
    body.append("parameters[original][h]", 400);
    body.append("parameters[thumbnail][w]", 200);
    body.append("parameters[thumbnail][h]", 150);

    fetch(window.masterConfig.baseUrl + "galleries/inlineGallery/", {
      method: "POST",
      body: body,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var originals = (data && data.original && data.original.files) || [];
        var thumbs = (data && data.thumbnail && data.thumbnail.files) || [];
        if (!originals.length) return;

        var ul = document.createElement("ul");
        ul.className =
          "grid grid-cols-2 gap-2 min-[650px]:grid-cols-3 min-[800px]:grid-cols-4";

        originals.forEach(function (image, i) {
          var thumb = thumbs[i] || image;

          var li = document.createElement("li");
          var a = document.createElement("a");
          a.href = image.thumbnail;
          a.className = "block";
          if (image.title) a.setAttribute("data-sub-html", image.title);

          var img = document.createElement("img");
          img.src = thumb.thumbnail;
          img.alt = image.title || "";
          img.className = "h-[125px] w-full bg-line object-cover";

          a.appendChild(img);
          li.appendChild(a);
          ul.appendChild(li);
        });

        container.innerHTML = "";
        container.appendChild(ul);

        lightGallery(ul, {
          selector: "a",
          speed: 400,
          download: false,
        });
      })
      .catch(function (err) {
        console.error("inline gallery failed to load", err);
      });
  });

  // article font-size +/- controls (Newsstudios/view.ctp)
  var fontsizeControls = document.querySelector("[data-fontsize-controls]");
  if (fontsizeControls) {
    var articleTextEls = document.querySelectorAll(".article-body p, .article-body div");
    fontsizeControls.querySelectorAll("[data-fontsize]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var delta = btn.getAttribute("data-fontsize") === "inc" ? 2 : -2;
        articleTextEls.forEach(function (el) {
          var current = parseInt(getComputedStyle(el).fontSize, 10) || 16;
          var next = current + delta;
          if (next >= 9 && next <= 25) {
            el.style.fontSize = next + "px";
          }
        });
      });
    });
  }

  // short-link copy button (content/tools)
  document.querySelectorAll("[data-short-link]").forEach(function (wrap) {
    var input = wrap.querySelector("[data-short-link-input]");
    var copied = wrap.querySelector("[data-short-link-copied]");
    var label = wrap.querySelector("label");
    if (!input || !label) return;
    label.addEventListener("click", function (e) {
      e.preventDefault();
      var showCopied = function () {
        if (!copied) return;
        copied.classList.remove("hidden");
        setTimeout(function () {
          copied.classList.add("hidden");
        }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(input.value).then(showCopied);
      } else {
        input.removeAttribute("readonly");
        input.select();
        document.execCommand("copy");
        input.setAttribute("readonly", "readonly");
        showCopied();
      }
    });
  });

  // comment form submit (comment/form)
  var commentForm = document.querySelector("[data-comment-form]");
  if (commentForm) {
    var form = commentForm.querySelector("form");
    var status = commentForm.querySelector("#commentStatus");
    var setCommentStatus = function (text) {
      if (status) {
        status.classList.remove("hidden");
        status.textContent = text;
      }
    };

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      setCommentStatus("در حال ارسال ...");
      var submitBtn = form.querySelector('input[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch(window.masterConfig.baseUrl + "comments/submit/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          object_master_id: commentForm.getAttribute("data-master-id"),
          category_id: commentForm.getAttribute("data-category-id"),
          model: commentForm.getAttribute("data-model"),
          BHT: window.masterConfig.blackHoleToken,
          "data[parent_id]": form.querySelector('input[name="parent"]').value,
          "data[comment_data][name]": form.querySelector('input[name="name"]').value,
          "data[comment_data][email]": form.querySelector('input[name="email"]').value,
          "data[comment_data][message]": form.querySelector('textarea[name="message"]').value,
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("request failed");
          setCommentStatus("نظر شما با موفقیت ثبت شد.");
        })
        .catch(function () {
          setCommentStatus("ارسال نظر با مشکل مواجه شده است.");
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  // comment reply-to (comment/list) — points the hidden "parent" field at the clicked comment
  document.querySelectorAll("[data-reply-to]").forEach(function (link) {
    link.addEventListener("click", function () {
      var parentField = document.querySelector('#commentForm input[name="parent"]');
      if (parentField) parentField.value = link.getAttribute("data-reply-to");
    });
  });

  // comment rating +/- (comment/list)
  document.querySelectorAll("[data-rate]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var masterId = btn.getAttribute("data-master-id");
      var type = btn.getAttribute("data-rate") === "plus" ? "+" : "-";
      fetch(
        window.masterConfig.baseUrl +
          "rates/score/?" +
          new URLSearchParams({ object_master_id: masterId, type: type }).toString()
      )
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          var plusEl = document.getElementById("rateplus" + masterId);
          var minusEl = document.getElementById("rateminus" + masterId);
          if (plusEl) plusEl.textContent = data.plus;
          if (minusEl) minusEl.textContent = data.minus;
        })
        .catch(function (err) {
          console.error("rate score failed", err);
        });
    });
  });
});
